import styled from 'styled-components';

export default styled.div`
  && {
    .info-clinic {
      background-color: white;
      width: 1128px;
      height: 291px;
      margin: 0px auto;
      border-radius: 10px;
      .name-clinic {
        padding: 18px 0px 10px 0px;
        text-align: center;
        border-bottom: 2px solid #eeeeee;
      }
      .clinic {
        .col-clinic {
          margin-left: 155px;
          .info {
            border-bottom: 1px solid #dddddd;
            padding: 16px 0px 17px 0px;
          }
          .info:first-child {
            padding-top: 27px;
          }
          .info:last-child {
            border-bottom: none;
          }
        }
        .col-bill {
          margin-left: 45px;
          padding-top: 17px;
          .bill:first-child {
            margin-bottom: 12px;
          }
          .bill {
            height: 86px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            .bill-title {
              margin-right: 15px;
              padding-left: 15px;
            }
            .bill-month-amount {
              padding: 22px 15px;
              background-color: white;
            }
          }
          .bill-month {
            background-color: #c1e18d;
          }
          .bill-forward {
            background-color: #eeeeee;
            .color-diff {
              color: #777777;
            }
          }
        }
      }
    }
    .deposit-amount {
      margin-top: 59px;
      margin-left: 170px;
      .input-deposit {
        display: flex;
        align-items: center;
        margin: 7px 0px 0px 0px;
      }
      .bill-add {
        height: 86px;
        width: 572px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        .bill-title {
          margin-right: 15px;
          padding-left: 15px;
        }
        .bill-add-amount {
          padding: 22px 15px;
          background-color: white;
        }
      }
      .bill-month {
        background-color: #ecffb8;
      }
    }
  }
`;
